import { isTrade } from 'chairisher/context/auth';
import { isLiveChatActive } from 'chairisher/context/site';
import { AmplitudeEventProperty, logAmplitudeButtonClickEvent, logAmplitudeEvent } from 'chairisher/util/analytics';

/**
 * Messaging Web Widget events we report to Amplitude, keyed by the event name passed to `messenger:on`.
 * The value is the `zendesk action` property sent with the event.
 *
 * @see https://developer.zendesk.com/api-reference/widget-messaging/web/events/
 */
const TRACKED_MESSENGER_EVENT_NAME_TO_ACTION = {
    articleBrowserClicked: 'article browser clicked',
    articleClicked: 'article clicked',
    close: 'closed',
    conversationAgentAssigned: 'agent assigned',
    conversationStarted: 'conversation started',
    conversationWithAgentRequested: 'agent requested',
    newConversationButtonClicked: 'new conversation button clicked',
    preConversationShown: 'pre conversation shown',
    proactiveMessageClicked: 'proactive message clicked',
    proactiveMessageDisplayed: 'proactive message displayed',
};

/**
 * Tracks when the zendesk messenger opens
 *
 * @param {string=} trackingPosition Optional tracking position to include with event
 * @see https://developer.zendesk.com/api-reference/widget-messaging/web/events/#on-open
 */
export function trackStartChatSession(trackingPosition) {
    if (isLiveChatActive()) {
        window.zE('messenger:on', 'open', () => {
            const eventProps = {};
            if (isTrade()) {
                eventProps[AmplitudeEventProperty.USER_TYPE] = 'Trade';
            }
            if (trackingPosition) {
                eventProps[AmplitudeEventProperty.POSITION] = trackingPosition;
            }
            logAmplitudeButtonClickEvent('Open Zendesk Widget', eventProps);
        });
    }
}

/**
 * Binds zendesk messenger event tracking, replacing the Classic widget's `userEvent` stream
 *
 * @param {string=} trackingPosition Optional tracking position to include with events
 */
export function bindTrackUserEvents(trackingPosition) {
    if (isLiveChatActive()) {
        Object.entries(TRACKED_MESSENGER_EVENT_NAME_TO_ACTION).forEach(([eventName, action]) => {
            window.zE('messenger:on', eventName, () => {
                const eventProps = {
                    [AmplitudeEventProperty.ZE_ACTION]: action,
                    [AmplitudeEventProperty.ZE_CATEGORY]: 'messaging',
                };
                if (isTrade()) {
                    eventProps[AmplitudeEventProperty.USER_TYPE] = 'Trade';
                }
                if (trackingPosition) {
                    eventProps[AmplitudeEventProperty.POSITION] = trackingPosition;
                }
                logAmplitudeEvent('zendesk widget', eventProps);
            });
        });
    }
}
